import React from "react";
export function Footer() {
  return <footer className="bg-navy px-4 pb-28 pt-12 text-center" data-id="element-177" data-mp="19ivlq3plplne">
      <p className="font-serif text-xl font-extrabold text-white" data-id="element-178" data-mp="208c9wx5nktlv">Implant Planning Playbook™</p>
      <p className="mt-2 text-[15px] text-white/75" data-id="element-179" data-mp="2f53dzjq9utht">Plan with structure. Decide with clarity. Prepare before you operate.</p>
      <p className="mt-6 text-sm text-white/60" data-id="element-180" data-mp="2a71u4wl0uq5a">© 2026 · Dr. Michael Carter · Implant Planning Playbook™ · All rights reserved.</p>
    </footer>;
}